module.exports = "https://static.wmbcdn.com/uniweb/images/485176143eb97bda240aa08f4169ddcb.png";